<template>
  <div>
    <PageHead title="通知列表"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">通知标题：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入通知标题"
                v-model="queryForm.titleName"
              />
            </div>
            <div class="query-view mr20">
              <div class="query-view-lable">送达时间：</div>
              <a-range-picker
                allowClear
                class="w200"
                v-model="timeHorizon"
                valueFormat="YYYY-MM-DD HH:mm:ss"
              >
                <a-icon slot="schedule" type="smile"
              /></a-range-picker>
            </div>
            <div class="query-view">
              <div class="query-view-lable">发送状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.sendState"
              >
                <a-select-option :value="0">未发送</a-select-option>
                <a-select-option :value="1">已发送</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="goDetial()" icon="plus">
          发送通知</a-button
        >
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>

      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <a-button
          type="link"
          slot="sendCount"
          slot-scope="text, record"
          @click="lookConT(record.sendCountList)"
        >
          {{ text }}
        </a-button>
        <a-button
          type="link"
          slot="affirmTrue"
          slot-scope="text, record"
          @click="lookConT(record.affirmTrueList)"
        >
          {{ text }}
        </a-button>
        <a-button
          type="link"
          slot="affirmFalse"
          slot-scope="text, record"
          @click="lookConT(record.affirmFalseList)"
        >
          {{ text }}
        </a-button>
        <div slot="sendState" class="statusDiv" slot-scope="text">
          <span v-if="text == 0"> 未发送 </span>
          <span v-if="text == 1"> 已发送 </span>
        </div>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0"> 待提交 </span>
          <span v-if="text == 1"> 正在审批 </span>
          <span v-if="text == 2"> 已归档 </span>
          <span v-if="text == 3"> 退回 </span>
          <span v-if="text == 4"> 取消 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goDetial(record.id, 1)"
          >
            查看
          </a-button>
          <template
            v-if="
              (record.sendType == 2 || record.sendType == 3) &&
              record.state == 2
            "
          >
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="downloadResult(record)"
            >
              下载短信发送结果
            </a-button>
          </template>
          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goDetial(record.id)">
              编辑
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button>
          </template>
          <!-- || record.sendType == 3 -->
          <!-- 1 站内信 2 短信  3 全部 -->
          <template
            v-if="
              record.state !== 0 &&
              record.affirmTrue == 0 &&
              record.sendType == 2
            "
          >
            <a-divider type="vertical" />

            <a-button
              type="link"
              class="btn-link"
              @click="withdrawParty(record.id)"
            >
              撤回
            </a-button>
          </template>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80
  },

  {
    title: '通知标题',
    dataIndex: 'titleName',
    key: 'titleName',
    ellipsis: true
  },

  {
    title: '送达时间',
    dataIndex: 'sendTime',
    key: 'sendTime',
    ellipsis: true
  },
  {
    title: '主送',
    dataIndex: 'sendCount',
    key: 'sendCount',
    scopedSlots: { customRender: 'sendCount' },
    ellipsis: true
  },
  {
    title: '已查看',
    dataIndex: 'affirmTrue',
    key: 'affirmTrue',
    scopedSlots: { customRender: 'affirmTrue' },
    ellipsis: true
  },
  {
    title: '未查看',
    dataIndex: 'affirmFalse',
    key: 'affirmFalse',
    scopedSlots: { customRender: 'affirmFalse' },
    ellipsis: true
  },
  {
    title: '发送状态',
    dataIndex: 'sendState',
    key: 'sendState',
    scopedSlots: { customRender: 'sendState' },
    ellipsis: true
  },
  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 350
  }
]

import {
  mfNoticeList,
  mfNoticeDelete,
  mfNoticeWithdrawParty,
  exportNoticeResult
} from './api/api'
export default {
  data() {
    return {
      timeHorizon: [], //时间范围
      queryForm: {},
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },

  created() {
    this.load()
  },
  methods: {
    // 下载短信发送结果
    downloadResult(record) {
      //下载模板 smsNoticeExport
      exportNoticeResult(record.id).then((response) => {
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = '发送结果.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    // 查看名称
    lookConT(list) {
      if (list.length > 0) {
        let title = ''
        list.forEach((item, index) => {
          title = index > 0 ? title + '、' + item : title + item
        })
        this.$warning({
          // width: "600px",
          title: title
        })
      }
    },
    // 拉取列表
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        params.startTime = this.timeHorizon[0]
        params.endTime = this.timeHorizon[1]
      } else {
        delete params.startTime
        delete params.endTime
      }
      mfNoticeList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          mfNoticeDelete({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    withdrawParty(id) {
      this.$confirm({
        title: '确定撤回吗?',
        okType: 'danger',
        onOk: () => {
          mfNoticeWithdrawParty({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('撤回成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    goDetial(id, type) {
      if (type) {
        const { href } = this.$router.resolve({
          path: '/notificationDetail',
          query: {
            id: id,
            isEdit: '1'
          }
        })
        window.open(href, '_self')
      } else {
        if (id) {
          const { href } = this.$router.resolve({
            path: '/notificationDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_self')
        } else {
          const { href } = this.$router.resolve({
            path: '/notificationDetail'
          })
          window.open(href, '_self')
        }
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
      this.timeHorizon = []
    },
    subMit() {
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/notification/index.vue